import React from "react";

import { useHistory } from "react-router-dom";

import { Banner, Button, NotificationSnackbar, StickyActionBar, Tabs } from "shared/ui";

import { MENU_SETTINGS_TABS } from "features/MenuSettings/constants";
import { MenuSettingsContext } from "features/MenuSettings/context";
import { useActiveTab } from "features/MenuSettings/hooks/useActiveTab";
import { useMenuSettingsState } from "features/MenuSettings/hooks/useMenuSettingsState";
import { MenuSettingsTab } from "features/MenuSettings/types";
import { TariffPromptDialog } from "features/MenuSettings/components/TariffPromptDialog";
import { AppearanceTab } from "features/MenuSettings/components/tabs/AppearanceTab";
import { ChatsTab } from "features/MenuSettings/components/tabs/ChatsTab";
import { GeneralTab } from "features/MenuSettings/components/tabs/GeneralTab";
import { OrderMethodsTab } from "features/MenuSettings/components/tabs/OrderMethodsTab";
import { PaymentsTab } from "features/MenuSettings/components/tabs/PaymentsTab";
import { SettingsTab } from "features/MenuSettings/components/tabs/SettingsTab";

import { ActionGroup, Container, Notices, Spacer, TabPanel } from "./styles";

const renderTab = (tab: MenuSettingsTab) => {
    switch (tab) {
        case "general":
            return <GeneralTab />;
        case "settings":
            return <SettingsTab />;
        case "appearance":
            return <AppearanceTab />;
        case "orderMethods":
            return <OrderMethodsTab />;
        case "payments":
            return <PaymentsTab />;
        case "chats":
            return <ChatsTab />;
    }
};

const MenuSettingsComponent = () => {
    const history = useHistory();
    const [activeTab, setActiveTab] = useActiveTab();
    const state = useMenuSettingsState();

    if (state.loading) {
        return <Container>Загрузка настроек…</Container>;
    }

    if (state.error) {
        return <Container>Не удалось загрузить настройки меню</Container>;
    }

    return (
        <MenuSettingsContext.Provider value={state}>
            <Container>
                <Notices>
                    {state.isTariffOverdue && (
                        <Banner tone="warning" title="Тариф просрочен">
                            До отключения ваших меню {state.menusAliveText}
                        </Banner>
                    )}
                    {state.hasExternalIntegration && (
                        <Banner tone="info" title="Включена интеграция с iiko">
                            Заказы напрямую идут в iiko.
                        </Banner>
                    )}
                </Notices>

                <Tabs
                    value={activeTab}
                    tabs={MENU_SETTINGS_TABS}
                    onChange={setActiveTab}
                />

                <TabPanel>{renderTab(activeTab)}</TabPanel>

                <StickyActionBar>
                    <Spacer />
                    <ActionGroup>
                        <Button
                            variant="outlined"
                            color="neutral"
                            onClick={() => history.goBack()}
                        >
                            Назад
                        </Button>
                        <Button
                            variant="contained"
                            disabled={state.saving}
                            onClick={state.save}
                        >
                            Сохранить
                        </Button>
                    </ActionGroup>
                </StickyActionBar>

                <TariffPromptDialog
                    level={state.tariffPrompt}
                    onClose={() => state.setTariffPrompt(null)}
                />

                <NotificationSnackbar {...state.notify.snackbarProps} />
            </Container>
        </MenuSettingsContext.Provider>
    );
};

export const MenuSettings = MenuSettingsComponent;
